import axios from "axios";
import {EvidenceInclusion} from "../components/ideas/store/types";

const API_DOMAIN = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN;

// Get Filtered Ideas
export const getFilteredIdeas = async (
  filters: any,
  sort: { [name: string]: 1 | -1 },
  limit: number,
  skip: number,
  tabName: string,
  auth0: any,
  archived: boolean,
  evidenceInclusion?: EvidenceInclusion
): Promise<{ totalCount: number; ideas: any[] }> => {
  try {

    const url = `${API_DOMAIN}/ideas/filters_query`;
    const response = await axios.post(
      url,
      { filters, sort, limit, skip, tabName, archived, evidenceInclusion });
    return response.data;
  } catch (e: any) {
    console.error("Error getting filtered ideas:", e);
    throw e;
  }
};

// Get Filtered Themes (Bagel AI tab - theme-level rows)
export const getFilteredThemes = async (
  filters: any,
  sort: { [name: string]: 1 | -1 },
  limit: number,
  skip: number,
  auth0: any,
  evidenceInclusion?: EvidenceInclusion
): Promise<{ totalCount: number; themes: any[] }> => {
  try {
    const url = `${API_DOMAIN}/ideas/bagel-ai-themes`;
    const response = await axios.post(
      url,
      { filters, sort, limit, skip, evidenceInclusion });
    return response.data;
  } catch (e: any) {
    console.error("Error getting filtered themes:", e);
    throw e;
  }
};

// Calculate Aggregations
export const calculateAggregations = async (
  aggregationColumns: string[],
  ideaIds: string[] | undefined,
  filters: any,
  auth0: any,
  evidenceInclusion?: EvidenceInclusion,
  themeItems?: { themeKey: string; evidenceIds: string[] }[]
): Promise<any> => {
  try {
    const url = `${API_DOMAIN}/ideas/calculate-aggregations`;
    const body: any = { aggregationColumns, filters, evidenceInclusion };
    if (themeItems && themeItems.length > 0) {
      body.themeItems = themeItems;
    } else {
      body.ideaIds = ideaIds;
    }
    const response = await axios.post(url, body);
    return response.data;
  } catch (e: any) {
    console.error("Error calculating aggregations:", e);
    throw e;
  }
};

export const getIdeasByIds = async (
  ideaIds: string[],
  auth0: any
): Promise<{ ideas: Record<string, unknown>[] }> => {
  try {
    const url = `${API_DOMAIN}/ideas/by-ids`;
    const response = await axios.post(url, { ideaIds });
    return response.data;
  } catch (e: any) {
    console.error('Error getting ideas by ids:', e);
    throw e;
  }
};
